class SaftSubscriberService extends AbstractSubscriberService
	@register()
	@inject 'BACKEND_SUBSCRIBER_PERIOD'

	hasShop: ->
		return true

	hasRegister: ->
		return true

	getPeriods: ->
		return [
			@BACKEND_SUBSCRIBER_PERIOD.DAILY,
			@BACKEND_SUBSCRIBER_PERIOD.MONTHLY,
		]

	getRequiredFields: ->
		return [
			'shop_id',
			'register_id'
		]
